import { i18n } from "@lingui/core"
import { HeadProps, PageProps } from "gatsby"
import * as React from "react"

import { LocalizedPageContext } from "../../locales/lingui"
import CatalogPageContent from "../../page-components/catalog"
import { CategoryKey } from "../../page-components/catalog/catalog-panel/types"
import Seo from "../../shared-components/seo"

function CatalogPage({ location }: PageProps) {
  const params = new URLSearchParams(location.search)
  const category = params.get("category") as CategoryKey
  return <CatalogPageContent downloadable category={category} />
}

export function Head({
  pageContext,
  ...props
}: HeadProps<unknown, LocalizedPageContext>) {
  i18n.activate(pageContext.locale)

  return (
    <Seo
      title={i18n._("Gift Card Catalog from Tremendous")}
      description={i18n._(
        "The Tremendous catalog offers tons of gift card choices that recipients love, from Amazon to prepaid Visas. Book a demo to see how our reward platform works.",
      )}
      {...props}
    />
  )
}

export default CatalogPage
